"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 *  判断是否包含字母
 * @param {Number} data
 */
var checkContainLetter = exports.checkContainLetter = function checkContainLetter(data) {
  return (/^[^A-Za-z]*$/g.test(data)
  );
};
/**
 *  判断是否全是字母
 * @param {Number} data
 */
var checkLetter = exports.checkLetter = function checkLetter(data) {
  return (/^[a-zA-Z]+$/g.test(data)
  );
};
/**
 *  判断是否全是小写字母
 * @param {Number} data
 */
var checkLowercaseLetter = exports.checkLowercaseLetter = function checkLowercaseLetter(data) {
  return (/^[a-z]+$/g.test(data)
  );
};
/**
 *  判断是否全是大写字母
 * @param {Number} data
 */
var checkCapitalLetter = exports.checkCapitalLetter = function checkCapitalLetter(data) {
  return (/^[A-Z]+$/g.test(data)
  );
};
/**
 * 判断是否是字母或数字
 * @param {Number || String} data  字符或数字
 */
var checkNumOrLetter = exports.checkNumOrLetter = function checkNumOrLetter(data) {
  return (/^[0-9a-zA-Z]*$/g.test(data)
  );
};
/**
 * 判断是否全是中文
 * @param {String} data  中文
 */
var checkChinese = exports.checkChinese = function checkChinese(data) {
  return (/^[\u4E00-\u9FA5]+$/g.test(data)
  );
};
/**
 * 判断是否是中文或数字
 * @param {String} data  中文
 */
var checkChineseNumber = exports.checkChineseNumber = function checkChineseNumber(data) {
  return (/^((?:[\u3400-\u4DB5\u4E00-\u9FEA\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29]|[\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0])|(\d))+$/g.test(data)
  );
};
/**
 * [checkChineseNumberLetter 判断是否是中文，数字或字母]
 *
 * @param   {[type]}  data  [data description]
 *
 * @return  {[type]}        [return description]
 */
var checkChineseNumberLetter = exports.checkChineseNumberLetter = function checkChineseNumberLetter(data) {
  return (/^[a-zA-Z0-9\u4e00-\u9fa5]+$/g.test(data)
  );
};
/**
 * 判断是否是邮箱地址
 * @param {String} data
 */
var checkEmail = exports.checkEmail = function checkEmail(data) {
  return (/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/g.test(data)
  );
};
/**
 *  判断是否是手机号（13,14,15,16,17,18,19）
 * @param { string } data
 */
var checkTel = exports.checkTel = function checkTel(data) {
  return (/^(?:(?:\+|00)86)?1[3-9]\d{9}$/g.test(data)
  );
};
/**
 * [checkSpecial 判断是否有特殊符号]
 *
 * @param   {[type]}  data  [data description]
 *
 * @return  {[type]}        [return description]
 */
var checkSpecial = exports.checkSpecial = function checkSpecial(data) {
  return RegExp(/[(\ )(\~)(\!)(\@)(\#)(\$)(\%)(\^)(\&)(\*)(\()(\))(\-)(\_)(\+)(\=)(\[)(\])(\{)(\})(\|)(\\)(\;)(\:)(\')(\")(\,)(\.)(\/)(\<)(\>)(\?)(\)]+/).test(data);
};
exports.default = {
  checkContainLetter: checkContainLetter,
  checkLetter: checkLetter,
  checkLowercaseLetter: checkLowercaseLetter,
  checkCapitalLetter: checkCapitalLetter,
  checkNumOrLetter: checkNumOrLetter,
  checkChinese: checkChinese,
  checkChineseNumber: checkChineseNumber,
  checkChineseNumberLetter: checkChineseNumberLetter,
  checkEmail: checkEmail,
  checkTel: checkTel,
  checkSpecial: checkSpecial
};